var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import request from '../api/request';
import ppt from './module/ppt';
import tts from './module/tts';
import tcts from './module/tcts';
import intelligence from './module/intelligence';
import { createStore } from 'vuex';
var initQuery = {
    // 对话内容
    keyword: '',
    link: [],
    type: '',
    modelId: '',
    translateType: '',
    writeQuery: {},
    is_create: false,
    images: [],
    model: '',
    fileAnalyseUrl: []
};
export default createStore({
    state: {
        chatQuery: JSON.parse(JSON.stringify(initQuery)), // 对话内容
        histroyIndex: 1, // 历史导航下标
        histroyList: [], // 历史消息
        drawHistroyList: [], // 绘画历史消息
        simpleList: [], // 智能体
        isCollapse: false, // 侧边栏状态
        loginStatus: false, //登录弹窗是否开启
        userInfo: {}, // 用户信息
        histroyOther: {
            // 历史记录相关
            status: false // 清空历史状态
        },
        autoplayAudio: false, // 自动播放声音
        voiceSpeaking: false, // 按住说话
        version_dic: {
            status: false,
            newVersion: '',
            nowVersion: ''
        }
    },
    getters: {},
    mutations: {
        // 存储对话内容
        setChat: function (state, playload) {
            Object.keys(playload).forEach(function (key) {
                if (state.chatQuery.hasOwnProperty(key)) {
                    state.chatQuery[key] = playload[key];
                }
            });
        },
        // 初始化
        initChat: function (state, playload) {
            state.chatQuery = JSON.parse(JSON.stringify(initQuery)); // 对话内容
        },
        // 操作侧边栏
        handleCollapse: function (state, playload) {
            state.isCollapse = playload || false;
        },
        // 获取历史消息
        setHistroyList: function (state, playload) {
            return __awaiter(this, void 0, void 0, function () {
                var res, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, request.get('/app-api/lt/ai/chat/conversation/my-list', {})];
                        case 1:
                            res = _a.sent();
                            state.histroyList = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? JSON.parse(JSON.stringify(res.data)) : [];
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        // 获取绘画历史消息
        setDrawHistroyList: function (state, playload) {
            return __awaiter(this, void 0, void 0, function () {
                var res, error_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, request.post('/app-api/lt/ai/image/getSessionList', {})];
                        case 1:
                            res = _b.sent();
                            state.drawHistroyList = Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.list) ? JSON.parse(JSON.stringify(res.data.list)) : [];
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _b.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        // 存储智能体列表
        setSimpleList: function (state, playload) {
            return __awaiter(this, void 0, void 0, function () {
                var res, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, request.get('/app-api/lt/ai/chat/model/simple-list', {
                                    status: 0
                                })];
                        case 1:
                            res = _a.sent();
                            state.simpleList = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? JSON.parse(JSON.stringify(res.data)) : [];
                            return [3 /*break*/, 3];
                        case 2:
                            error_3 = _a.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        // 存储登录状态
        setLoginStatus: function (state, playload) {
            state.loginStatus = (playload === null || playload === void 0 ? void 0 : playload.status) || false;
        },
        // 存储用户信息
        setUserInfo: function (state, playload) {
            state.userInfo = playload || {};
        },
        // 历史状态相关
        setHistroyOther: function (state, playload) {
            console.log(88888, playload);
            typeof playload === 'object' &&
                Object.keys(playload).forEach(function (key) {
                    if (key in state.histroyOther) {
                        state.histroyOther[key] = playload[key];
                    }
                });
        },
        // 存储历史选择导航
        setHistroyIndex: function (state, playload) {
            state.histroyIndex = playload || 0;
        },
        // 存储播放声音状态
        setAutoplayAudio: function (state, playload) {
            state.autoplayAudio = playload || false;
        },
        // 存储按住说话状态
        setVoiceSpeaking: function (state, playload) {
            state.voiceSpeaking = playload || false;
        },
        // 存储版本信息
        setVersionDic: function (state, playload) {
            state.version_dic.nowVersion = playload || '';
            // 判断版本是否大于
            function compareVersions(v1, v2) {
                var parts1 = v1.split('.').map(Number);
                var parts2 = v2.split('.').map(Number);
                var maxLength = Math.max(parts1.length, parts2.length);
                for (var i = 0; i < maxLength; i++) {
                    var num1 = parts1[i] || 0;
                    var num2 = parts2[i] || 0;
                    if (num1 > num2)
                        return 1;
                    if (num1 < num2)
                        return -1;
                }
                return 0;
            }
            state.version_dic.status = compareVersions(state.version_dic.newVersion, state.version_dic.nowVersion) == 1;
            console.log('当前版本：' + state.version_dic.newVersion, '新版本: ' + playload);
        },
    },
    actions: {
        // 获取用户信息
        getUserInfo: function (state, playload) {
            return new Promise(function (resolve, reject) {
                request
                    .get('/app-api/member/user/get', {})
                    .then(function (res) {
                    state.commit('setUserInfo', res === null || res === void 0 ? void 0 : res.data);
                    resolve(res);
                })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
        // 获取线上版本
        getAndroidVresion: function (state, playload) {
            return new Promise(function (resolve, reject) {
                request
                    .get('/app-api/rag-apk-version/check-update?currentVersion=' + state.state.version_dic.nowVersion, {})
                    .then(function (res) {
                    var _a;
                    state.state.version_dic.newVersion = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.version) || '';
                    // 告知版本
                    var androidBride = window.androidBride;
                    if (androidBride) {
                        androidBride.getAndroidVersion('');
                    }
                    resolve(res);
                })
                    .catch(function (err) {
                    reject(err);
                });
            });
        },
    },
    modules: {
        ppt: ppt,
        tts: tts,
        tcts: tcts,
        intelligence: intelligence
    }
});
